import { render, staticRenderFns } from "./OilTankCostDetail.vue?vue&type=template&id=298aeb2f&scoped=true"
import script from "./OilTankCostDetail.vue?vue&type=script&lang=js"
export * from "./OilTankCostDetail.vue?vue&type=script&lang=js"
import style0 from "./OilTankCostDetail.vue?vue&type=style&index=0&id=298aeb2f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298aeb2f",
  null
  
)

export default component.exports